import { render } from "./monthlyBillings.vue?vue&type=template&id=6410f1c6&scoped=true"
import script from "./monthlyBillings.vue?vue&type=script&lang=js"
export * from "./monthlyBillings.vue?vue&type=script&lang=js"

import "./monthlyBillings.vue?vue&type=style&index=0&id=6410f1c6&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6410f1c6"]])

export default __exports__